import tokens from './tokens'
import { PoolConfig, PoolCategory } from './types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { calculateMjtV2MigrateBlock } from './index'

dayjs.extend(utc)

const MJT_PER_BLOCK = calculateMjtV2MigrateBlock(1).multipliedBy(0.9)
const MJT_PER_BLOCK_V2 = calculateMjtV2MigrateBlock(2).multipliedBy(0.9)

// when adding new pool, pls keep sousId the same as sortOrder
const pools: PoolConfig[] = [
  {
    name: 'Manual MJT',
    sousId: 0,
    stakingToken: tokens.mjt,
    earningToken: tokens.mjt,
    contractAddress: {
      322: '0x84F10c60Aa2d69aA38Ae307D3bd57e2825BD5617',
      321: '0x25C6d6A65C3ae5d41599Ba2211629B24604Fea4F',
    },
    poolCategory: PoolCategory.Manual,
    harvest: true,
    tokenPerBlock: String(MJT_PER_BLOCK.multipliedBy(0.25)),
    sortOrder: 0,
    isFinished: false,
  },
  {
    name: 'Auto MJT',
    sousId: 0,
    stakingToken: tokens.mjt,
    earningToken: tokens.mjt,
    contractAddress: {
      322: '0x516dbE24c123C35930ef217553C177f81be0E64B',
      321: '0xF0D7C82E9f9bE85b2d1F8bedE40Afe1c1Fa7560c',
    },
    poolCategory: PoolCategory.Auto,
    harvest: true,
    tokenPerBlock: String(MJT_PER_BLOCK.multipliedBy(0.25)),
    sortOrder: 1, // Never change it,it's the unique tag for AutoPool
    isFinished: false,
  },
  // {
  //   name: 'Earn KCS',
  //   sousId: 2,
  //   stakingToken: tokens.mjt,
  //   earningToken: tokens.wkcs,
  //   contractAddress: {
  //     322: '0x9BCF38167448A8736FB32cd05CaDB3C2024681e9',
  //     321: '0x326D754c64329aD7cb35744770D56D0E1f3B3124',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   tokenPerBlock: '0.000000001',
  //   sortOrder: 2,
  //   isFinished: false,
  // },
  // {
  //   name: 'Earn MJT',
  //   sousId: 3,
  //   stakingToken: tokens.wkcs,
  //   earningToken: tokens.mjt,
  //   contractAddress: {
  //     322: '0x447e2935A8D070F17DEF31113669aE93d76FeF58',
  //     321: '0x555Ea72d7347E82C614C16f005fA91cAf06DCB5a',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   tokenPerBlock: '0.1',
  //   sortOrder: 3,
  //   isFinished: false,
  // },
  // {
  //   name: 'Earn USDT',
  //   sousId: 4,
  //   stakingToken: tokens.mjt,
  //   earningToken: tokens.usdt,
  //   contractAddress: {
  //     322: '0x2A0746E62da421a9F5A282771D5bE41e39655b0F',
  //     321: '0x555Ea72d7347E82C614C16f005fA91cAf06DCB5a',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   tokenPerBlock: '1',
  //   sortOrder: 4,
  //   isFinished: false,
  // },
]

export const poolsV2: PoolConfig[] = [
  {
    name: 'Manual MJT',
    sousId: 0,
    stakingToken: tokens.mjt,
    earningToken: tokens.mjt,
    contractAddress: {
      322: '0xc7CBbb318318242fCC314ec723269d9E41ff6B4D',
      321: '0xfdfcE767aDD9dCF032Cbd0DE35F0E57b04495324',
    },
    poolCategory: PoolCategory.Manual,
    harvest: true,
    tokenPerBlock: String(MJT_PER_BLOCK_V2.multipliedBy(0.25)),
    sortOrder: 0,
    isFinished: false,
  },
  {
    name: 'Auto MJT',
    sousId: 0,
    stakingToken: tokens.mjt,
    earningToken: tokens.mjt,
    contractAddress: {
      322: '0x2010C439DA6fC2557eC582B8F4807715fF0ecf23',
      321: '0x3db85383aB912C9D9C003Bd2ec09107E0f37B8A0',
    },
    poolCategory: PoolCategory.Auto,
    harvest: true,
    tokenPerBlock: String(MJT_PER_BLOCK_V2.multipliedBy(0.25)),
    sortOrder: 1, // Never change it,it's the unique tag for AutoPool
    isFinished: false,
  },
]

export default pools
